export default {
      id: "map-point-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "img/icons.svg#map-point",
      toString: function () {
        return this.url;
      }
    }